import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataTermsOfPayment } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_TERMS_OF_PAYMENT =
  defineMasterdataEntity<MasterdataTermsOfPayment>({
    name: 'terms-of-payment',
    responseKey: 'termsOfPayments',
    displayWith: (t) => keyName(t.key, t.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-money-check-dollar',
    title: 'Zahlungskonditionssuche',
    label: 'Zahlungskondition',
    placeholder: 'Zahlungskondition suchen...',
    columns: [
      {
        label: 'Zahlungskondition',
        type: 'entity',
        icon: 'fa-regular fa-money-check-dollar',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', value: (e) => e.key },
      { label: 'Bezeichnung', value: (e) => e.name },
      { label: 'Skonto 1', value: (e) => e.cashDiscount1 },
      { label: 'Skonto 2', value: (e) => e.cashDiscount2 },
      { label: 'Tage 1', value: (e) => e.days1 },
      { label: 'Tage 2', value: (e) => e.days2 },
      { label: 'Fälligkeitstage', value: (e) => e.dueDays },
      { label: 'Art', value: (e) => e.type?.name ?? null },
      { label: 'Aktiv', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  });
